import RenderObject from "../render/renderobject";
import ShaderService from "../shader/shader_service";
import ResourceService from "../resource/resourceservice";
import Camera from "./camera";
import { CollisionVolume } from "../collision/collision_volume";
import CollisionService from "../collision/collision_service";
import Placement from "./placement";
import VolumePlacement from "../collision/volume_placement";
import Attachment from "../animation/attachment";

export default class SceneObject extends RenderObject
{
     children: SceneObject[] = [];
     collisionVolumes: CollisionVolume[] = [];
     placement:Placement;
     volume_placement: VolumePlacement;
     attachments: Attachment[] = [];
     attached_children: { child: SceneObject; attachment_name: string }[] = [];

    constructor(key:string)
    {
        super(key);
        this.placement = new Placement(this);
        this.volume_placement = new VolumePlacement(this);
    }

     add_child(child: SceneObject): void 
     {
        this.children.push(child);
     }

     remove_child(child: SceneObject): void 
     {
      const idx = this.children.findIndex((so) => so === child);
      if (idx >= 0) 
      {
            this.children.splice(idx, 1);
      }
  }
      

      add_collision_volume(volume: CollisionVolume): void {
    volume.owner = this;
    this.collisionVolumes.push(volume);
  }

  add_attachment(attachment: Attachment): void 
  {
     this.attachments.push(attachment);
  }

get_attachment(name: string): Attachment | null {
  for (const a of this.attachments) {
    if (a.name === name) return a;
  }
  return null;
}

attach_child(child: SceneObject, attachment_name: string): void {
  this.attached_children.push({ child, attachment_name });
}

detach_child(child: SceneObject): void {
  const idx = this.attached_children.findIndex((ac) => ac.child === child);
  if (idx >= 0) {
    this.attached_children.splice(idx, 1);
  }
}

update_attachments(): void {
  for (const attachment of this.attachments) {
    attachment.update(this);
  }

  for (const ac of this.attached_children) {
    const attachment = this.get_attachment(ac.attachment_name);
    if (!attachment) continue;

    // Preserve the child's own scale when setting from attachment
    const child = ac.child;
    const sx = child.transform.scale[0];
    const sy = child.transform.scale[1];
    const sz = child.transform.scale[2];

    child.transform.set_from_matrix(attachment.world_matrix);

    child.transform.set_scale(sx, sy, sz);
    child.transform.update_matrix();

  
  }
}

  register_collisions(collisionService: CollisionService): void {
    for (const volume of this.collisionVolumes) {
      collisionService.register(volume);
    }

    for (const child of this.children) {
      child.register_collisions(collisionService);
    }
  }

  unregister_collisions(collisionService: CollisionService): void {
    for (const volume of this.collisionVolumes) {
      collisionService.unregister(volume);
    }

    for (const child of this.children) {
      child.unregister_collisions(collisionService);
    }
  }



    async build(device: GPUDevice,format: GPUTextureFormat,shader_service: ShaderService, resource_service: ResourceService): Promise<void> 
    {
        for (const child of this.children) {
        await child.build(device, format, shader_service, resource_service);
        }
    }

    tick(delta_time: number): void 
    {
        for (const child of this.children) 
        {
            child.tick(delta_time);
        }
  }

  prepare(device: GPUDevice, camera: Camera): void
  {
    for (const child of this.children) {
      child.prepare(device, camera);
    }
  }

  draw(pass: GPURenderPassEncoder): void 
  {
    for (const child of this.children) {
      child.draw(pass);
    }
  }

  ui_message(cmd: string, msg: string): void 
  {
    for (const child of this.children)
    {
      child.ui_message(cmd, msg);
    }
  }
  
}